import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

const AddMansioni = () => {
  const [loading, setLoading] = useState(false);
  const [nomeMansione, setNomeMansione] = useState("");
  const [descrizioneMansione, setDescrizioneMansione] = useState("");
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  const isValid = () => {
    const inputErrors = {};
    if (nomeMansione.trim() === "") {
      inputErrors.nomeMansione = "Il campo Nome Mansione non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const addMansioni = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/mansioni", {
        nomeMansione,
        descrizioneMansione,
      });

      if (response.status === 200 || response.data?.status === 200) {
        toast.success("Mansioni aggiunta con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/mansioni");
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per aggiungere una mansione!");

      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  if (!isAuthorized) return null;

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Aggiungi Mansione</div>
        <div className="header-actions">
          <button onClick={() => navigate("/mansioni")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Mansioni
          </button>
        </div>
      </div>

      <div className="page-content add-mansioni">
        <div className="form-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-plus-circle"></i>
              Nuova Mansione
            </div>
          </div>

          <div className="card-content">
            <div className="form-field">
              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-briefcase"></i>
                  Nome Mansione
                </label>
                <div className="form-input">
                  <input
                    type="text"
                    id="nomeMansione"
                    value={nomeMansione}
                    onChange={(e) => {
                      setNomeMansione(e.target.value);
                      if (errors.nomeMansione && e.target.value.trim() !== "") {
                        setErrors((prev) => {
                          const newErrors = { ...prev };
                          delete newErrors.nomeMansione;
                          return newErrors;
                        });
                      }
                    }}
                    placeholder="Inserisci il nome della mansione"
                    className="modern-input"
                  />
                  {errors.nomeMansione && (
                    <span className="error-message">{errors.nomeMansione}</span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-align-left"></i>
                  Descrizione Mansione
                </label>
                <div className="form-input">
                  <textarea
                    id="descrizioneMansione"
                    value={descrizioneMansione}
                    onChange={(e) => {
                      setDescrizioneMansione(e.target.value);
                      if (
                        errors.descrizioneMansione &&
                        e.target.value.trim() !== ""
                      ) {
                        setErrors((prev) => {
                          const newErrors = { ...prev };
                          delete newErrors.descrizioneMansione;
                          return newErrors;
                        });
                      }
                    }}
                    placeholder="Inserisci una descrizione dettagliata della mansione"
                    className="modern-textarea"
                    rows={6}
                  />
                  {errors.descrizioneMansione && (
                    <span className="error-message">
                      {errors.descrizioneMansione}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-summary">
              <div className="summary-item">
                <i className="fa-solid fa-info-circle"></i>
                <span>Compila tutti i campi per creare una nuova mansione</span>
              </div>
            </div>
          </div>

          <div className="card-actions">
            <button
              className="cancel-btn"
              onClick={() => navigate("/mansioni")}
            >
              <i className="fa-solid fa-times"></i>
              Annulla
            </button>
            <button className="save-btn" onClick={addMansioni}>
              <i className="fa-solid fa-save"></i>
              Aggiungi Mansione
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMansioni;
